import Default from './DefaultLayout';

export default Default;
